var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.40222C2 3.99842 2.32399 3.67108 2.72366 3.67108H15.2915C15.6911 3.67108 16.0151 3.99842 16.0151 4.40222C16.0151 4.80602 15.6911 5.13336 15.2915 5.13336H3.44732V20.5377H17.5271V11.4097C17.5271 11.0059 17.8511 10.6786 18.2508 10.6786C18.6505 10.6786 18.9744 11.0059 18.9744 11.4097V21.2689C18.9744 21.6727 18.6505 22 18.2508 22H2.72366C2.32399 22 2 21.6727 2 21.2689V4.40222Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2059 5.47478L18.5951 4.85131L12.3871 11.0593L12.0727 11.9916L12.9977 11.683L19.2059 5.47478ZM13.6038 12.5171L10.9217 13.4119C10.7785 13.4596 10.6075 13.2851 10.6561 13.1409L11.5676 10.4386L19.3841 2.62217C20.4343 2.15145 21.8216 3.46849 21.4564 4.5896L21.4202 4.70063L13.6038 12.5171ZM20.5948 4.08589L19.7718 4.90888L19.161 4.28541L19.9918 3.45457C20.3073 3.3995 20.6648 3.75862 20.5948 4.08589Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/EditWhite.2f403cb7d893870b5ec84fa986ea85d8.svg";
export { ForwardRef as ReactComponent };